/* eslint-disable no-unused-vars */
import {
  get as getAxios,
  post as postAxios,
  put as putAxios,
} from "../apiHandler";

const endPoint = process.env.REACT_APP_API_BASE_URL;

const get = (url, { data, accessToken }) =>
  getAxios(url, { data, accessToken, endPoint });
const post = (url, { accessToken, data, params }) =>
  postAxios(url, { accessToken, data, endPoint, params });
const put = (url, { accessToken, data, params }) =>
  putAxios(url, { accessToken, data, endPoint, params });

export default class Attendance {
  static getAttendance({ data, meetingType }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/meetings/${meetingType}/attendees`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Attendance.getAttendance.cancel = request.cancel;
    return request;
  }

  static markAttendance({ data, meetingType }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/meetings/${meetingType}/markAttendance`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Attendance.markAttendance.cancel = request.cancel;
    return request;
  }

  static getAttendanceReport(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reporting/attendance/drilldown`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Attendance.getAttendanceReport.cancel = request.cancel;
    return request;
  }

  static getOtherMeetingAttendance({ data, meetingType }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(
      `/api/meetings/${meetingType}/attendees-other-meeting`,
      {
        accessToken: accessTokenFromLocal,
        data: {},
      }
    );

    Attendance.getOtherMeetingAttendance.cancel = request.cancel;
    return request;
  }

  static markOtherMeetingAttendance({ data, meetingType }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(
      `/api/meetings/${meetingType}/markAttendanceOtherMeeting`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Attendance.markOtherMeetingAttendance.cancel = request.cancel;
    return request;
  }

  static getArchiveAttendance({ data, meetingType, from, to }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/meetings/${meetingType}/archive/attendees`, {
      accessToken: accessTokenFromLocal,
      data: {
        ...data,
        from,
        to,
      },
    });

    Attendance.getArchiveAttendance.cancel = request.cancel;
    return request;
  }
}
